<div class="wrapper">
  <div class="flex items-center justify-center px-0 lg:px-5 py-5 bg-transparent">
    <div class="bg-gray-100 text-black rounded shadow-xl w-full overflow-hidden p-3 intro flex flex-col" style="max-width:1000px">
      <div class="text-2xl font-bold">Welkom bij De Osse Groei</div>
      <div class="italic mb-4">De website waarop je op spelende wijze de industrialisatie van Oss beleeft.</div>
      <iframe class="w-full mb-4" style="height: 400px;" src="https://www.youtube.com/embed/mnKalFiS5HQ" allowfullscreen></iframe>
      <div class="mb-4 flex justify-center">
        <button (click)="clickStart()" class='bg-black hover:bg-gray-800 text-white p-2 rounded text-2xl font-bold'>Start ontdekkingsreis</button>
      </div>
      <div class="italic mb-4">Disclaimer: De Osse Groei is het afstudeerproject van oud-journalistiekstudent <a class="underline hover:font-bold cursor-pointer" href="https://nl.linkedin.com/in/yoerinijs" target="_blank">Yoeri Nijs</a>. De site, gemaakt in 2012, is een eerbetoon aan de duizenden (oud-)werknemers van Unox en Organon. In 2021 is de site volledig herbouwd. De oorspronkelijke verhalen zijn grotendeels intact gelaten om de tijdsgeest van toen te illustreren.</div>
    </div>
  </div>
  <app-fog></app-fog>
</div>

<app-footer></app-footer>
